import { render } from "./UserClient.vue?vue&type=template&id=049e8731"
import script from "./UserClient.vue?vue&type=script&lang=js"
export * from "./UserClient.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__